<template>
  <!-- APP BAR -->
  <v-app-bar border flat class="app-bar pb-2">
    <v-container class="d-flex align-center justify-space-between">
      <!-- BRAND -->
      <v-img
        class="brand"
        src="@/assets/logo.png"
        height="64"
        contain
        @click="$router.push('/')"
      />

      <!-- DESKTOP MENU -->
      <div class="desktop-menu">
        <v-btn to="/" variant="text">Home</v-btn>
        <v-btn to="/products" variant="text">Shop</v-btn>
        <v-btn to="/about" variant="text">About</v-btn>
        <!-- <v-btn to="/contact" variant="text">Contact</v-btn> -->

        <!-- SEARCH (DESKTOP) -->
        <v-text-field
          v-model="search"
          placeholder="Search products"
          density="compact"
          variant="outlined"
          hide-details
          clearable
          class="search-input"
          @keyup.enter="goToSearch"
          @click:clear="clearSearch"
        />

        <!-- CART ICON (DESKTOP) -->
        <v-btn class="ms-4 cart-btn" icon to="/cart">
          <v-badge
            v-if="cartCount > 0"
            :content="cartCount"
            color="primary"
            class="cart-badge"
          >
            <v-icon>mdi-cart-outline</v-icon>
          </v-badge>

          <v-icon v-else>mdi-cart-outline</v-icon>
        </v-btn>
      </div>

      <!-- MOBILE ACTIONS -->
      <div class="mobile-actions">
        <!-- SEARCH ICON -->
        <v-btn icon @click="showMobileSearch = true">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <!-- CART ICON -->
        <v-btn icon to="/cart">
          <v-badge v-if="cartCount > 0" :content="cartCount" color="primary">
            <v-icon>mdi-cart-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-cart-outline</v-icon>
        </v-btn>

        <!-- MENU ICON -->
        <v-btn icon class="mobile-menu" @click="drawer = true">
          <v-icon color="primary">mdi-menu</v-icon>
        </v-btn>
      </div>
    </v-container>
  </v-app-bar>

  <!-- MOBILE DRAWER -->
  <v-navigation-drawer v-model="drawer" location="right" temporary width="280">
    <v-container>
      <v-list nav>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.to"
          @click="drawer = false"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-btn
        color="primary"
        block
        class="mt-6"
        to="/products"
        @click="drawer = false"
      >
        Shop Now
      </v-btn>
    </v-container>
  </v-navigation-drawer>

  <!-- MOBILE SEARCH DIALOG -->
  <v-dialog v-model="showMobileSearch" width="90%">
    <v-card class="pa-4">
      <v-text-field
        v-model="search"
        label="Search products"
        autofocus
        clearable
        @keyup.enter="goToSearch"
        @click:clear="clearSearch"
      />

      <v-btn color="primary" block class="mt-3" @click="goToSearch">
        Search
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { cart } from "@/store/cart";

export default {
  name: "AppHeader",

  data() {
    return {
      drawer: false,
      showMobileSearch: false,
      search: "",
      cart,
      menuItems: [
        { title: "Home", to: "/" },
        { title: "Shop", to: "/products" },
        { title: "About", to: "/about" },
        // { title: "Contact", to: "/contact" },
      ],
    };
  },

  computed: {
    cartCount() {
      return this.cart.items.reduce((sum, item) => sum + item.qty, 0);
    },
  },

  watch: {
    search(value) {
      if (!value) {
        this.$router.push({ path: "/products" });
      } else {
        this.$router.push({
          path: "/products",
          query: { q: value },
        });
      }
    },
  },

  methods: {
    goToSearch() {
      if (!this.search?.trim()) return;

      this.showMobileSearch = false;

      this.$router.push({
        path: "/products",
        query: { q: this.search },
      });
    },

    clearSearch() {
      this.search = "";
      this.$router.push({ path: "/products" });
    },
  },
};
</script>

<style>
/* BRAND */

.brand {
  max-height: 64px;
  width: auto;
}

.brand .v-img__img {
  object-fit: contain;
  cursor: pointer;
  width: unset;
}

.cart-badge .v-badge__badge {
  color: #eee7da !important; /* green */
}

/* Mobile screens */
@media (max-width: 600px) {
  .brand {
    max-height: 52px;
  }
}

@media (max-width: 960px) {
  .brand {
    max-height: 58px;
  }
}

/* APP BAR */
.app-bar {
  padding-top: 12px;
}

/* DESKTOP MENU */
.desktop-menu {
  display: flex;
  align-items: center;
  gap: 12px;
}

.desktop-menu .v-btn--active {
  background: #490917;
  color: #eee7da;
}

.desktop-menu .cart-btn.v-btn--active {
  background: #ffffff;
  color: #000000;
}

/* SEARCH */
.search-input {
  width: 260px;
  min-width: 220px;
}

/* MOBILE */
.mobile-actions {
  display: none;
  gap: 6px;
}

.mobile-menu {
  display: none;
}

.drawer-brand {
  font-family: "Playfair Display", serif;
  font-weight: 600;
}

/* RESPONSIVE */
@media (max-width: 960px) {
  .desktop-menu {
    display: none;
  }

  .mobile-actions {
    display: flex;
    align-items: center;
  }

  .mobile-menu {
    display: inline-flex;
  }
}
</style>
